var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells",class:[_vm.prefixCls,!_vm.showBorderTop?'clear-top':'',!_vm.showBorderBottom?'clear-bottom':''],on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"weui-cell breadcrumb"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a67a370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/persion/TitleCell.vue
// module id = 253
// module chunks = 0